import type { Permission } from 'types';
import { ROLES, type Role } from 'constants/roles';

const permissionMatrix: Record<Role, Permission[]> = {
  [ROLES.STUDENT]: [
    'course:view',
    'lesson:view',
    'batch:view',
    'batch:enroll',
    'school:view',
    'community:view',
    'certificate:view',
    'ai:view',
  ],
  [ROLES.TEACHER]: [
    'course:view',
    'course:create',
    'course:edit',
    'lesson:view',
    'lesson:create',
    'lesson:edit',
    'batch:view',
    'batch:manage',
    'school:view',
    'community:view',
    'community:moderate',
    'certificate:view',
    'ai:view',
  ],
  [ROLES.TEACHING_ASSISTANT]: [
    'course:view',
    'lesson:view',
    'batch:view',
    'batch:manage',
    'school:view',
    'community:view',
    'community:moderate',
    'ai:view',
  ],
  [ROLES.COORDINATOR]: [
    'course:view',
    'course:manage',
    'lesson:view',
    'batch:view',
    'batch:manage',
    'school:view',
    'school:manage',
    'user:view',
    'user:manage',
    'community:view',
    'community:moderate',
    'admin:view',
    'analytics:view',
    'certificate:view',
    'ai:view',
  ],
  [ROLES.CONTENT_TEAM]: [
    'course:view',
    'course:create',
    'course:edit',
    'lesson:view',
    'lesson:create',
    'lesson:edit',
    'school:view',
    'ai:view',
  ],
  [ROLES.RESEARCH_TEAM]: [
    'course:view',
    'lesson:view',
    'school:view',
    'community:view',
    'ai:view',
    'analytics:view',
  ],
  [ROLES.ADMIN]: [
    'course:view',
    'course:create',
    'course:edit',
    'course:delete',
    'course:manage',
    'lesson:view',
    'lesson:create',
    'lesson:edit',
    'lesson:delete',
    'batch:view',
    'batch:manage',
    'school:view',
    'school:manage',
    'user:view',
    'user:manage',
    'community:view',
    'community:moderate',
    'admin:view',
    'admin:manage',
    'analytics:view',
    'payment:view',
    'payment:manage',
    'certificate:view',
    'certificate:manage',
    'ai:view',
  ],
  [ROLES.SUPER_ADMIN]: [
    'course:view',
    'course:create',
    'course:edit',
    'course:delete',
    'course:manage',
    'lesson:view',
    'lesson:create',
    'lesson:edit',
    'lesson:delete',
    'batch:view',
    'batch:manage',
    'school:view',
    'school:manage',
    'user:view',
    'user:manage',
    'community:view',
    'community:moderate',
    'admin:view',
    'admin:manage',
    'analytics:view',
    'payment:view',
    'payment:manage',
    'certificate:view',
    'certificate:manage',
    'ai:view',
  ],
};

export function hasPermission(roles: string[], permission: Permission): boolean {
  return roles.some((role) => {
    const roleKey = role as Role;
    return permissionMatrix[roleKey]?.includes(permission) ?? false;
  });
}

export function hasAnyRole(roles: string[], allowedRoles: Role[]): boolean {
  return roles.some((role) => allowedRoles.includes(role as Role));
}

export { permissionMatrix };
